import { render, staticRenderFns } from "./Write.vue?vue&type=template&id=71cd395a&scoped=true"
import script from "./Write.vue?vue&type=script&lang=js"
export * from "./Write.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cd395a",
  null
  
)

export default component.exports